/**
 * Generate a random UUID (v4-like)
 */
const generateUUID = () => {
  if (typeof window === 'undefined') return 'server-side';

  // Use crypto.randomUUID if available (modern browsers)
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  // Fallback implementation
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Get or create the device signature stored in browser localStorage
 * @returns {string} The device signature UUID
 */
export const getDeviceSignature = () => {
  if (typeof window === 'undefined') {
    return 'server-side';
  }

  let signature = localStorage.getItem('pm_device_signature');
  if (!signature) {
    signature = generateUUID();
    localStorage.setItem('pm_device_signature', signature);
  }

  return signature;
};
